export const drawerWidth = 272;
export const fadeInDuration = 450;
